import { useEffect, useState } from "react";
import { Package, ShoppingBag, Users, AlertTriangle, MessageSquare, RefreshCw, DollarSign } from "lucide-react";
import api from "../../lib/api";
import GeoStats from "../../components/admin/GeoStats";

const Stat = ({ icon: Icon, label, value, accent }) => (
  <div className="card-luxe p-6">
    <div className="flex items-start justify-between">
      <div>
        <div className="overline mb-2">{label}</div>
        <div className={`font-display text-3xl ${accent? "text-copper" : "text-white"}`}>{value}</div>
      </div>
      <Icon size={20} className="text-white/30"/>
    </div>
  </div>
);

export default function AdmOverview() {
  const [s, setS] = useState({});
  useEffect(()=>{ api.get("/admin/stats").then(r=>setS(r.data)); }, []);
  return (
    <div className="space-y-8">
      <div><div className="overline mb-2">Store</div><h1 className="font-display text-4xl text-white">Welcome back</h1></div>
      <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
        <Stat icon={DollarSign} label="Revenue" value={`AED ${(s.revenue||0).toLocaleString()}`} accent/>
        <Stat icon={Package} label="Orders" value={s.total_orders||0}/>
        <Stat icon={ShoppingBag} label="Products" value={s.total_products||0}/>
        <Stat icon={Users} label="Customers" value={s.total_users||0}/>
        <Stat icon={AlertTriangle} label="Out of Stock" value={s.out_of_stock||0}/>
        <Stat icon={AlertTriangle} label="Low Stock" value={s.low_stock||0}/>
        <Stat icon={MessageSquare} label="Open Enquiries" value={s.pending_enquiries||0}/>
        <Stat icon={RefreshCw} label="Refund Requests" value={s.pending_refunds||0}/>
      </div>
      <div className="card-luxe p-6">
        <div className="overline mb-4">Recent Orders</div>
        {(s.recent_orders||[]).map(o => (
          <div key={o.id} className="flex justify-between text-sm py-3 border-b border-white/5 last:border-0">
            <div><div className="text-white">{o.order_number}</div><div className="text-white/40 text-xs">{o.customer_name} · {o.customer_email}</div></div>
            <div className="text-right"><div className="text-copper">AED {o.total.toLocaleString()}</div><div className="text-white/40 text-xs uppercase tracking-luxe">{o.status}</div></div>
          </div>
        ))}
        {(s.recent_orders||[]).length === 0 && <div className="text-white/40 text-sm">No orders yet</div>}
      </div>
      <GeoStats />
    </div>
  );
}
